import facebook from '../assets/img/icons/facebookicon.svg'
import instagram from '../assets/img/icons/instagramicon.svg'
import tiktok from '../assets/img/icons/tiktokicon.svg'
import twitter from '../assets/img/icons/twittericon.svg'

const footerIcons = [
    {
        index: 0,
        icon: facebook
    },
    {
        index: 1,
        icon: instagram
    },
    {
        index: 2,
        icon: tiktok
    },
    {
        index: 3,
        icon: twitter
    }
]

export default footerIcons